import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { PostHogProvider } from 'posthog-js/react';
import { getCookie, parseConsent } from './components/auth/PrivacyBanner';

const posthogOptions = {
  api_host: process.env.REACT_APP_POSTHOG_HOST,
  defaults: '2025-05-24',
};

const consent = parseConsent(getCookie('privacy_consent'));
const analyticsAllowed = !!consent && consent.analytics === true;

const root = ReactDOM.createRoot(document.getElementById('root'));
if (analyticsAllowed) {
  root.render(
    <PostHogProvider apiKey={process.env.REACT_APP_POSTHOG_KEY} options={posthogOptions}>
      <App />
    </PostHogProvider>
  );
} else {
  root.render(<App />);
}

reportWebVitals(); 